import { takeEvery, all, select, put, call } from 'redux-saga/effects';
import { GET } from 'utils/request';
import { GET_MY, REQUEST_DATA_RESULT } from '../../containers/App/constants';
import {
  FILTER_DEFAULT_LIMIT,
  REQUEST_TRANSPORT_ORDERS,
  REQUEST_TRANSPORT_ORDER_FILTER,
  REQUEST_TRANSPORT_ORDER_FILTER_RESET,
  APPLY_TRANSPORT_ORDER_FILTERS,
  APPLY_TRANSPORT_ORDER_FILTERS_SEPARATE_LIST,
} from './constants';
import { selectTransportOrderFilter, selectTransportOrderSeparateListFilter } from './selectors';

function* requestTransportOrderFilter(action, options = {}) {
  let filter = yield select(
    options.separateList || action?.separateList ? selectTransportOrderSeparateListFilter() : selectTransportOrderFilter(),
  );
  console.log('Filters to send: ', filter);
  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let text = filter.searchString?.trim() || null;
  const sortType = filter?.sortType;
  const order = filter?.order;

  let path = `transport-orders/getList`;

  const isDoneStatusFilter = filter.properties?.find(f => f.key === 'status' && f.value[0] === 'done');
  const isCanceledStatusFilter = filter.properties?.find(f => f.key === 'status' && f.value[0] === 'canceled');
  const inversedDoneStatus = {
    key: 'status',
    value: ['done'],
    label: ['transport_order.filter.done'],
    type: 'single',
    inversed: true,
  };
  const inversedCanceledStatus = {
    key: 'status',
    value: ['canceled'],
    label: ['transport_order.filter.canceled'],
    type: 'single',
    inversed: true,
  };

  let filterProperties = [...filter.properties];

  // if (!isDoneStatusFilter) {
  //   filterProperties?.push(inversedDoneStatus);
  // }
  if (!isCanceledStatusFilter && !filter?.getDeleted) {
    filterProperties?.push(inversedCanceledStatus);
  }

  let searchParams = {
    offset,
    limit,
    text: text ?? undefined,
    filters: filterProperties?.map(f => (f.value?.id ? { ...f, value: [f.value.id + ''] } : f)),
  };

  if (!!sortType) {
    searchParams.sortType = sortType;
    searchParams.order = order ?? 'desc';
  }

  yield put({
    type: GET_MY,
    id: REQUEST_TRANSPORT_ORDERS,
    work: REQUEST_TRANSPORT_ORDERS,
    gate: REQUEST_TRANSPORT_ORDERS,
    separateList: (options.separateList || action.separateList) ?? null,
    path,
    post: searchParams,
  });
}

export function* transportOrderSaga() {
  yield all([
    takeEvery(APPLY_TRANSPORT_ORDER_FILTERS, requestTransportOrderFilter),

    takeEvery(APPLY_TRANSPORT_ORDER_FILTERS_SEPARATE_LIST, function*(action) {
      yield call(requestTransportOrderFilter, action, { separateList: true });
    }),
    takeEvery(REQUEST_TRANSPORT_ORDER_FILTER, requestTransportOrderFilter),
    takeEvery(REQUEST_TRANSPORT_ORDER_FILTER_RESET, requestTransportOrderFilter),
  ]);
}
